import React from 'react';

import { i18n } from 'config/locales';

import { IDENTIFICATION, IDENTIFICATION_PHYSICAL } from 'config/formSections/identification';
import connectSubsection from 'components/Section/shared/SubsectionConnector';
import Subsection from 'components/Section/shared/Subsection';

import * as formTypes from 'constants/formTypes';
import Show from 'components/Form/Show';
import Field from 'components/Form/Field';
import Height from 'components/Form/Height';
import Weight from 'components/Form/Weight';
import HairColor from 'components/Form/HairColor';
import EyeColor from 'components/Form/EyeColor';
import Sex from 'components/Form/Sex';
import { isFormSF852013 } from 'helpers/form';
import { MILITARY_SELECTIVE } from 'constants/sections';
import Comments from 'components/Form/Comments';

const sectionConfig = {
  key: IDENTIFICATION_PHYSICAL.key,
  section: IDENTIFICATION.name,
  store: IDENTIFICATION.store,
  subsection: IDENTIFICATION_PHYSICAL.name,
  storeKey: IDENTIFICATION_PHYSICAL.storeKey,
};

export class Physical extends Subsection {
  constructor(props) {
    super(props);

    const {
      section, subsection, store, storeKey
    } = sectionConfig;

    this.section = section;
    this.subsection = subsection;
    this.store = store;
    this.storeKey = storeKey;
    this.formType = props.formType;
    this.handleUpdate = this.handleUpdate.bind(this);
  }

  handleUpdate(field, values) {
    this.props.onUpdate(this.storeKey, {
      Height: this.props.Height,
      Weight: this.props.Weight,
      HairColor: this.props.HairColor,
      EyeColor: this.props.EyeColor,
      Sex: this.props.Sex,
      Comments: this.props.Comments,
      [field]: values,
    }, [MILITARY_SELECTIVE]);
  }

  render() {
    const { formType, formVersion } = this.props;
    const klass = `section-content physical ${this.props.className || ''}`.trim();

    return (
      <div
        className={klass}
        data-section={IDENTIFICATION.key}
        data-subsection={IDENTIFICATION_PHYSICAL.key}
      >
        <h1 className="section-header">{i18n.t('identification.destination.physical')}</h1>

        <Show when={this.formType !== formTypes.SF852013}>
          <Field
            title={i18n.t('identification.traits.heading.height')}
            titleSize="h4"
            help="identification.traits.help.height"
            adjustFor="labels"
            scrollIntoView={this.props.scrollIntoView}
            shrink
            attribute="Height"
          >
            <Height
              attribute="Height"
              name="height"
              {...this.props.Height}
              onUpdate={(values) => {
                this.handleUpdate('Height', values); // eslint-disable-line @typescript-eslint/unbound-method
              }}
              onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
              required={this.props.required}
            />
          </Field>

          <Field
            title={i18n.t('identification.traits.heading.weight')}
            titleSize="h4"
            help="identification.traits.help.weight"
            adjustFor="labels"
            scrollIntoView={this.props.scrollIntoView}
            shrink
            attribute="Weight"
          >
            <Weight
              attribute="Weight"
              name="weight"
              {...this.props.Weight}
              onUpdate={(values) => {
                this.handleUpdate('Weight', values); // eslint-disable-line @typescript-eslint/unbound-method
              }}
              onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
              required={this.props.required}
            />
          </Field>

          <Field
            title={i18n.t('identification.traits.heading.hair')}
            titleSize="h4"
            adjustFor="big-buttons"
            scrollIntoView={this.props.scrollIntoView}
            help="identification.traits.help.hair"
            attribute="HairColor"
          >
            <HairColor
              attribute="HairColor"
              name="hair"
              help="identification.traits.help.hair"
              className=""
              {...this.props.HairColor}
              onUpdate={(values) => {
                this.handleUpdate('HairColor', values); // eslint-disable-line @typescript-eslint/unbound-method
              }}
              onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
              required={this.props.required}
            />
          </Field>

          <Field
            title={i18n.t('identification.traits.heading.eye')}
            titleSize="h4"
            adjustFor="big-buttons"
            scrollIntoView={this.props.scrollIntoView}
            help="identification.traits.help.eye"
            attribute="EyeColor"
          >
            <EyeColor
              attribute="EyeColor"
              name="eye"
              className=""
              {...this.props.EyeColor}
              onUpdate={(values) => {
                this.handleUpdate('EyeColor', values); // eslint-disable-line @typescript-eslint/unbound-method
              }}
              onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
              required={this.props.required}
            />
          </Field>
        </Show>

        <Field
          title={i18n.t('identification.traits.heading.sex')}
          titleSize="h4"
          adjustFor="big-buttons"
          scrollIntoView={this.props.scrollIntoView}
          shrink
          attribute="Sex"
        >
          <Sex
            attribute="Sex"
            name="sex"
            {...this.props.Sex}
            onUpdate={(values) => {
              this.handleUpdate('Sex', values); // eslint-disable-line @typescript-eslint/unbound-method
            }}
            onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
            required={this.props.required}
          />
        </Field>
        {!isFormSF852013(formType, formVersion) && (
          <Comments
            title={i18n.t('identification.traits.comment')}
            name="OptionalComment"
            attribute="Comments"
            className="physical-optional-comment"
            {...this.props.Comments}
            onUpdate={(values) => {
              this.handleUpdate('Comments', values); // eslint-disable-line @typescript-eslint/unbound-method
            }}
            required={false}
          />
        )}
      </div>
    );
  }
}

Physical.defaultProps = {
  Height: {},
  Weight: {},
  HairColor: '',
  EyeColor: '',
  Sex: '',
  Comments: {},
  onError: (value, arr) => arr,
  dispatch: () => { },
  required: false,
};

export default connectSubsection(Physical, sectionConfig);
